import Form     from 'scripts/poppet/form';
import template from 'templates/legacyLoginForm.jst.html';

/**
 * defa.views.LegacyLoginForm
 * A login form for legacy accounts.
 * @version 1.2.1
 */

const channelUser = Bb.Radio.channel( 'user' );

const selectors = {
	inputAll     : '[data-input]',
	inputUser    : '[data-input=legacy-user]',
	inputPassword: '[data-input=legacy-password]',
};

const LegacyLoginForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		inputs  : selectors.inputAll,
		user    : selectors.inputUser,
		password: selectors.inputPassword,
	},
	
	templateContext: function () {
		return {
			isTechSupport: this.isTechSupport(),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Checks if the password field should be required
	 * @returns {bool} True if the user is tech support, false if not.
	 */
	isTechSupport: function () {
		return channelUser.request( 'model' ).hasRoles( [ 'TECHNICAL_SUPPORT', ] );
	},
	
	/**
	 * Submit the form through the model.
	 * @void
	 */
	submit: function () {
		
		this.trigger( 'legacy:login', {
			user    : this.ui.user.val().trim(),
			password: this.ui.password.val().trim(),
		} );
	},
	
} );

export default LegacyLoginForm;